import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartDonut from '../../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'
import { STATUS_DELIVERED } from '../../../../types/Order'

const GET_DATA = gql`
  query StorePickup($filters: JSON) {
    ordersAggs(
      size: 0,
      filters: $filters
      query: {
        bool: {
          filter: [
            {
              term: {
                status_translate_keyword: "${STATUS_DELIVERED}"
              }
            }
          ]
        }
      },
      aggs: {
        deliveryType: {
          terms: {
            field: "shipping.type.keyword"
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number
}
const ShippingStorePickup = (): JSX.Element => {
  const { filters } = useContext(DailyMonitoringFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartDonutSkeleton />
  if (loading || !data) return <ChartDonutSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const buckets:Array<Bucket> = new Array<Bucket>()
  data.ordersAggs.aggregations.deliveryType.buckets.forEach((bucket: Bucket) => buckets.push(bucket))
  const labels: Array<string> = []
  const series: Array<number> = []
  buckets.sort((a:Bucket, b:Bucket) => parseInt(a.key) - parseInt(b.key))
  buckets.forEach((bucket: Bucket) => {
    labels.push(bucket.key)
    series.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'tipo-retirada'
    },
    labels,
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    legend: {
      formatter: function (seriesName: string, opts: any) {
        let total = 0
        opts.w.globals.series.map((serie: any) => {
          total += serie
        })

        return [seriesName, ' - ', formatNumber((opts.w.globals.series[opts.seriesIndex] / total) * 100, 2), '%']
      },
      width: 220,
      height: 300
    },
    plotOptions: {
      polarArea: {
        rings: {
          strokeWidth: 0
        },
        spokes: {
          strokeWidth: 0
        }
      }
    }
  }

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Retirada na loja</Typography>
    <ChartDonut options={options} series={series} theme={ChartColumnThemes.blue} type="donut" />
  </Paper>
}

export default ShippingStorePickup
